module.exports = __webpack_public_path__ + "static/media/sortingdown-theme.bc7e01cc.svg";